import { render, staticRenderFns } from "./selectWechat.vue?vue&type=template&id=919b3fc4&scoped=true"
import script from "./selectWechat.vue?vue&type=script&lang=js"
export * from "./selectWechat.vue?vue&type=script&lang=js"
import style0 from "./selectWechat.vue?vue&type=style&index=0&id=919b3fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919b3fc4",
  null
  
)

export default component.exports